import { customElement } from 'lit/decorators.js';
import store from '@mfe/store';
import {
  cancelPage, save, setCustomerAttribute,
} from '@mfe/store/consents';
import { TefComsCustomerAttributeInlineBase } from '@mfec/customerAttributes/TefComsCustomerAttributeInlineBase';
import { TemplatingMixin } from '@mfec/lit/mixins/TemplatingMixin';
import { connect } from 'pwa-helpers/connect-mixin';
import service from '@mfe/service';
import { templates } from './templates'; // eslint-disable-line import/no-cycle

const CompositeClass = TemplatingMixin(connect(store)(TefComsCustomerAttributeInlineBase), 'occl', templates);

@customElement('tef-coms-customer-attribute-inline')
export class TefComsCustomerAttributeInline extends CompositeClass {
  connectedCallback() {
    super.connectedCallback();
    // Only available here after store init and not on top of the class :(
    this.setTemplatingTheme(this.theme);

    if (!this.customerAttribute) {
      service.fireEvent('consents/ERROR', {
        level: 'error',
        message: `there is no customer attribute with id '${this.id}'`,
      });
      return;
    }

    // No editable customer attribute items?
    if (!this.hasAnyEditableCustomerAttributeItems) {
      service.fireEvent('consents/EMPTY', {
        level: 'info',
        message: 'there are no editable customer attribute items to be rendered',
      });
    }
  }

  save(): void {
    if (this.customerAttributeItemsStatusChanged) {
      store.dispatch(setCustomerAttribute(this.updatedCustomerAttribute));
      store.dispatch(save());
    }
  }

  cancel() {
    store.dispatch(cancelPage());
  }

  get customerAttributes() {
    const { consents: { customerAttributes } } = store.getState();
    return customerAttributes;
  }

  get theme() {
    const { config: { occluri } } = store.getState();
    return occluri ? 'occl' : 'tefOne';
  }

  getTemplateFnFor(templateName: string) {
    return this.getTemplateFn(templateName);
  }
}
